import React from 'react';
import styled from 'styled-components';

const UserReviewLeftComponent = () => (
  <UserReviewRightComponentWrapDiv>
    <StayComponentWrapDiv>
      <StayComponentLeftDiv>
        <NameFeildSpan></NameFeildSpan>
        <WriterFeildSpan></WriterFeildSpan>
      </StayComponentLeftDiv>
      <StayComponentRightDiv>
        <RatingFeildSpan></RatingFeildSpan>
      </StayComponentRightDiv>
    </StayComponentWrapDiv>

    <UserFeedBackComponentWrapDiv>
      <UserFeedBackPara></UserFeedBackPara>
      <UserFeedBackPara></UserFeedBackPara>
      <UserFeedBackPara></UserFeedBackPara>
    </UserFeedBackComponentWrapDiv>

    <UserImageUploadComponentWrapDiv>
      <UserImageUploadSpan></UserImageUploadSpan>
      <UserImageUploadSpan></UserImageUploadSpan>
    </UserImageUploadComponentWrapDiv>

    <UserLinkComponentWrapDiv></UserLinkComponentWrapDiv>
    <ResponseComponentWrapDiv></ResponseComponentWrapDiv>
  </UserReviewRightComponentWrapDiv>
);

export default UserReviewLeftComponent;

const UserReviewRightComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-left:${props.theme.spacing.small};
  padding-right:${props.theme.spacing.base};

  padding-bottom:${props.theme.spacing.large};
  width:95%;

`,
);

const StayComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  justify-content:space-between;

`,
);

const StayComponentLeftDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;

`,
);

const StayComponentRightDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: coloumn;
  padding-top:${props.theme.spacing.small};
  padding-bottom:${props.theme.spacing.small};
`,
);

const NameFeildSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:22.4rem;
  height:2.5rem;
  margin-bottom:${props.theme.spacing.small};

`,
);

const WriterFeildSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:14rem;
  height:1.6rem;


`,
);

const RatingFeildSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:4.2rem;
  height:3.5rem;


`,
);

const UserFeedBackComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:96%;
  padding-top:${props.theme.spacing.large};
  padding-bottom:${props.theme.spacing.large};

`,
);

const UserFeedBackPara = styled.p(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};

  height:2.5rem;
  margin-bottom:${props.theme.spacing.base};
`,
);

const UserImageUploadComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;

  padding-bottom:${props.theme.spacing.base}


`,
);

const UserImageUploadSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.large};
  width:11.4rem;
  height:11.4rem;
  margin-right:${props.theme.spacing.base};
`,
);

const UserLinkComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:24.7rem;
  height:2.5rem;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};

  margin-top:${props.theme.spacing.small};


`,
);

const ResponseComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:90%
  height:8.4rem;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  margin-top:${props.theme.spacing.large};

`,
);
